import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
const faqs = [{
  q: '¿Esto sirve si nunca trabajé mis emociones?',
  a: 'Sí, podés empezar desde cero. El sistema está diseñado para ser simple y progresivo.'
}, {
  q: '¿Está adaptado a Argentina?',
  a: 'Sí, el lenguaje y las situaciones que se plantean son reales y cercanas a nuestro contexto.'
}, {
  q: '¿Necesito experiencia previa?',
  a: 'No, las herramientas son prácticas y directas para que cualquier persona pueda aplicarlas.'
}, {
  q: '¿Qué pasa si no me gusta?',
  a: 'Tenés garantía total de 7 días. Te devolvemos el 100% de tu dinero sin preguntas.'
}];
export function FAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section className="bg-brand-dark py-5 px-5" data-id="element-101">
      <div className="max-w-xl mx-auto" data-id="element-102">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-white mb-8" data-id="element-103">
          ❓ Preguntas Frecuentes
        </h2>

        <div className="space-y-3" data-id="element-104">
          {faqs.map((faq, idx) => <div key={idx} className="bg-gray-900 border border-gray-800 rounded-xl overflow-hidden" data-id="element-105">
              <button className="w-full px-5 py-4 text-left flex justify-between items-center hover:bg-gray-800/50 focus:outline-none transition-colors" onClick={() => setOpenIdx(openIdx === idx ? null : idx)} data-id="element-106">
                <span className="font-bold text-white text-sm pr-4" data-id="element-107">
                  {faq.q}
                </span>
                {openIdx === idx ? <ChevronUp className="text-brand-yellow flex-shrink-0" size={18} data-id="element-108" /> : <ChevronDown className="text-gray-600 flex-shrink-0" size={18} data-id="element-109" />}
              </button>
              {openIdx === idx && <div className="px-5 pb-4 text-sm text-gray-400 leading-relaxed border-t border-gray-800" data-id="element-110">
                  <div className="pt-3" data-id="element-111">{faq.a}</div>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}